import { Slides } from 'ionic-angular';
import { Component, ViewChild } from '@angular/core';

@Component({
  selector: 'sharers',
  templateUrl: 'sharers.html'
})
export class SharersComponent {
  @ViewChild(Slides) slides: Slides;
  text: string;

  constructor() {
    console.log('Hello SharersComponent Component');
    this.text = 'Hello World';
  }

  slideChanged() {
    let currentIndex = this.slides.getActiveIndex();
    if (currentIndex>2 || currentIndex>=this.slides.length())
      this.slides.slideTo(0);
  }
}




// WEBPACK FOOTER //
// ./src/components/sharers/sharers.ts